import styled from "styled-components";

const LanguageSelectorStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px;

  button {
    background: ${({ theme }) => theme.colour.brokenWhite};
    border: 2px solid ${({ theme }) => theme.colour.main};
    border-radius: ${({ theme }) => theme.border.borderRadiusSmall};
    padding: 6px 12px;
    font-size: ${({ theme }) => theme.fonts.textFontSizeS};
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 40px;

    &:hover {
      background: ${({ theme }) => theme.colour.main};
      color: ${({ theme }) => theme.colour.white};
    }

    &.active {
      background: ${({ theme }) => theme.colour.main};
      color: ${({ theme }) => theme.colour.white};
    }
  }
`;

export default LanguageSelectorStyled;
